<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!-- title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["exportAdmin"] }} </h4>
        </div>
      
        <!-- form -->
        <div class="grid-body no-border borderBottom">

          <el-form v-loading="loading != 0">
            <div class="filters-wrapper">
              <div class="filters-row">
                <!-- FieldSite -->
                <el-form-item :label="i18nValues['fieldSite']" prop="fieldSite">
                  <el-select v-model="selectedfieldSites" :placeholder="i18nValues['fieldSite']" multiple>
                    <el-option :value="null"></el-option>
                    <el-option
                      v-for="item in fieldSites"
                      :key="item.value"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Order number -->
                <el-form-item :label="i18nValues['orderNumber']" prop="id">
                  <el-input
                    v-model="filter.id"
                    :placeholder="i18nValues['orderNumber']"
                  ></el-input>
                </el-form-item>
          
                <!-- Status -->
                <el-form-item :label="i18nValues['status']" prop="status">
                  <el-select v-model="selectedStatuses" :placeholder="i18nValues['status']" multiple>
                    <el-option :value="null"></el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :selected="options[2]"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Crop Type -->    
                <el-form-item :label="i18nValues['crop']" prop="cropType">
                  <el-select 
                    v-model="selectedCropTypes"
                    :placeholder="i18nValues['crop']"
                    multiple
                  >
                    <el-option
                      v-for="item in variedades"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Dispatch Type -->
                <el-form-item :label="i18nValues['dispatchType']" prop="dispatchType">
                  <el-select 
                    v-model="selectedDispatchTypes" 
                    :placeholder="i18nValues['dispatchType']"
                    multiple
                  >
                    <el-option
                      v-for="item in dispatchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- Creation Date From -->                
                <el-form-item :label="i18nValues['from']" prop="dispatchDateSince">
                  <div class="input-group">
                    <el-date-picker 
                      v-model="filter.dispatchDateSince"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['from']"
                    >
                    </el-date-picker>
                    <span class="input-group-addon primary el-input__suffix icon">
                      <span class="arrow"></span>
                      <i class="fa fa-calendar-alt"></i>
                    </span>
                  </div>
                </el-form-item>

                <!-- Creation Date Until -->                
                <el-form-item :label="i18nValues['to']" prop="dispatchDateUntil">
                  <div class="input-group">
                    <el-date-picker 
                      v-model="filter.dispatchDateUntil"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['to']"
                    >
                    </el-date-picker>
                    <span class="input-group-addon primary el-input__suffix icon">
                      <span class="arrow"></span>
                      <i class="fa fa-calendar-alt"></i>
                    </span>
                  </div>
                </el-form-item>
    
                <!-- search + export buttons -->
                <el-form-item label=" " class="btn-form-item">
                  <el-button
                    @click="retrieveOrdersForExport()"
                    icon="fas fa-search"
                    id="searchButton"
                    size="small"
                    class="btn-primary"
                  >
                    {{ i18nValues["search"] }}
                  </el-button>
                  <el-button
                    @click="exportExcel()"
                    icon="fas fa-file-excel"
                    size="small"
                    class="btn-primary"
                  >
                    {{ i18nValues["export"] }}
                  </el-button>
                </el-form-item>
              </div>
            </div>
        
      <!-- table -->
      <el-form-item prop="customers">
        <div style="margin:5 auto;padding:15px; width: 100%;"></div>
        <el-table v-if="OrdersList.length > 0"
          :data="OrdersSubList"
          class="table table-hover table-striped"
          id="CustomersTable"
          align="left"
          with="20%"
          :empty-text="i18nValues['noDataAvailable']"
          @sort-change="handleSortChange"
          >

          <!-- Customer Name -->
          <el-table-column
            prop="id" 
            :label="i18nValues['orderNumber']"
            width="4"
            align="left"
            sortable
          ></el-table-column>

          <!-- Status -->
          <el-table-column
              prop="status"
              :label="i18nValues['status']"
              width="5"
              align="center"
              sortable
          ></el-table-column>    

          <!-- Dispatch Type -->
          <el-table-column
              :label="i18nValues['dispatchType']"
              prop="dispatchType"
              width="5"
              align="center"
              sortable
          ></el-table-column>     

          <!-- Dispatch Date -->
          <el-table-column
              :label="i18nValues['dispatchDate']"
              prop="dispatchDate"
              width="6"
              :formatter="formatDispatchDate"
              align="center"
              sortable
          ></el-table-column>  

          <!-- FieldSite -->
          <el-table-column
              :label="i18nValues['fieldSite']"
              width="6"
              prop="fieldSite.name"
              align="center"
              sortable
          ></el-table-column>  

          </el-table>
          <div class="pagination-bar">
            <PaginationFunctional
              ref="pagination"
              sublistName="OrdersSubList"
              :fullList="OrdersList"
              :tableSize="20"
              :tableIndexInitial="initialPage"
              @paginationChange="paginationChange"
              @currentIndexPagination="setCurrentPage"
              class="text-center"
            />  
            <div v-if="OrdersList.length > 0" class="results-info">
              <p>
                {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
              </p>
            </div>
          </div>
      </el-form-item>

          </el-form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  import PaginationFunctional from "@/components/PaginationFunctional.vue"

  const normalizeDateInput = (value) => {
    if (value === undefined || value === null || value === "") {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    if (typeof value === "number") {
      const fromNumber = new Date(value);
      return isNaN(fromNumber.getTime()) ? null : fromNumber;
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) {
        return null;
      }
      const dateMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (dateMatch) {
        const year = Number(dateMatch[1]);
        const month = Number(dateMatch[2]) - 1;
        const day = Number(dateMatch[3]);
        const localDate = new Date(year, month, day);
        return isNaN(localDate.getTime()) ? null : localDate;
      }
      const parsed = new Date(trimmed);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    return null;
  };

  export default {
    name: "ExportAdmin",
    created() {
      this.restoreFromQuery();
      this.retrieveFieldSites();
    },

    components:{
      PaginationFunctional,
    }, 
  
    computed: {
    loading: get("exportXls/loading"),
    globalCampaign: get("globalCampaign"),
    selectedLanguage: get("i18nStore/selectedLanguage"),

      options() {
        return [
          { value: 'open', label: this.i18nValues["open"] },
          { value: 'forDispatch', label: this.i18nValues["forDispatch"] },
          { value: 'dispatched', label: this.i18nValues["dispatched"] },
          { value: 'inPort', label: this.i18nValues["inPort"] },
          { value: 'arrivedToDestination', label: this.i18nValues["arrivedToDestination"] },
        ];
      },

      dispatchOptions() {
        return [
          { value: "plane", label: this.i18nValues["aerial"] },
          { value: "ship", label: this.i18nValues["maritime"] },
        ];
      },

      // Pagination helpers for results label
      currentPage() {
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        return this.initialPage || 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
        return Array.isArray(this.OrdersList) ? this.OrdersList.length : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },
    },
  
    props:{
      componentsMap: {},
    },

    watch: {
      globalCampaign: {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal && oldVal && newVal.id === oldVal.id) return;
          // Only re-fetch if user has already searched (has data)
          if (this.originalOrdersList.length > 0) {
            this.fetchOrders(true);
          }
        },
      },
    },

    data() {
      const q = (this.$route && this.$route.query) || {};
      const parseQueryArray = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
          return value.split(',').filter(v => v && v.trim() !== '');
        }
        return [];
      };
      return {
        filter: {
          id: q.id || null,
          dispatchDateSince: normalizeDateInput(q.dispatchDateSince),
          dispatchDateUntil: normalizeDateInput(q.dispatchDateUntil),
        },
        
        variedades: [
                  { value: "corn", label: "Corn Seed" },
                  { value: "soy", label: "Soybean Production" },
                  { value: "soyRD", label: "Soybean R&D" },
        ],

        fieldSites: [],
        OrdersList: [],
        OrdersSubList: [],
        originalOrdersList: [],
        initialPage: q.page ? Number(q.page) : 1,
        sortProp: q.sortProp || null,
        sortOrder: q.sortOrder || null,
        requestGeneration: 0,

        selectedfieldSites: q.fieldSites ? parseQueryArray(q.fieldSites).map(id => Number(id)).filter(id => !isNaN(id)) : [],
        selectedStatuses: q.statuses ? parseQueryArray(q.statuses) : [],
        selectedCropTypes: q.cropTypes ? parseQueryArray(q.cropTypes) : [],
        selectedDispatchTypes: q.dispatchTypes ? parseQueryArray(q.dispatchTypes) : [],

      };
    },
  
    methods: {

    exportExcel(){
      const payload = this.buildFilterPayload();
      payload.selectedLanguage = this.selectedLanguage;
      
      this.$store.dispatch("exportXls/exportExcelOrder", payload).then((res) => {   
          var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const links = document.createElement("a");
          links.href = URL.createObjectURL(blob);
          
          // Generate descriptive filename based on filters
          let filename = "Ordenes_Exportacion";
          
          // If filtering by specific order number, use it in filename
          if (payload.id && String(payload.id).trim() !== "") {
            filename = "Orden_" + String(payload.id).trim();
          } else {
            // Add date range if specified
            if (payload.dispatchDateSince || payload.dispatchDateUntil) {
              const fromDate = payload.dispatchDateSince ? new Date(payload.dispatchDateSince).toISOString().split('T')[0] : "";
              const toDate = payload.dispatchDateUntil ? new Date(payload.dispatchDateUntil).toISOString().split('T')[0] : "";
              if (fromDate && toDate) {
                filename += "_" + fromDate + "_a_" + toDate;
              } else if (fromDate) {
                filename += "_desde_" + fromDate;
              } else if (toDate) {
                filename += "_hasta_" + toDate;
              }
            }
            
            // Add timestamp for uniqueness
            const timestamp = new Date().toISOString().split('T')[0];
            filename += "_" + timestamp;
          }
          
          links.download = filename + ".xlsx";
          links.click();
          URL.revokeObjectURL(links.href);
      });
    },

    retrieveFieldSites() {
        return this.$store.dispatch("fieldSite/retrieveFieldSites").then((res) => {
            this.fieldSites = res;
            return res;
        });
    },

    buildFilterPayload() {
      const payload = {
        fieldSites: "",
        campaignId: this.globalCampaign ? this.globalCampaign.id : null,
        status: "",
        cropType: "",
        dispatchType: "",
        id: this.filter.id || null,
        dispatchDateSince: null,
        dispatchDateUntil: null,
      };
      for (var a = 0; a < this.selectedfieldSites.length; a++) {
        payload.fieldSites += this.selectedfieldSites[a].toString() + ",";
      }
      for (var i = 0; i < this.selectedStatuses.length; i++) {
        payload.status += this.selectedStatuses[i] + ",";
      }
      for (var j = 0; j < this.selectedCropTypes.length; j++) {
        payload.cropType += this.selectedCropTypes[j] + ",";
      }
      for (var k = 0; k < this.selectedDispatchTypes.length; k++) {
        payload.dispatchType += this.selectedDispatchTypes[k] + ",";
      }
      if (this.filter.dispatchDateSince != null) {
        payload.dispatchDateSince = this.filter.dispatchDateSince instanceof Date
          ? this.filter.dispatchDateSince.getTime()
          : this.filter.dispatchDateSince;
      }
      if (this.filter.dispatchDateUntil != null) {
        payload.dispatchDateUntil = this.filter.dispatchDateUntil instanceof Date
          ? this.filter.dispatchDateUntil.getTime()
          : this.filter.dispatchDateUntil;
      }
      return payload;
    },

    fetchOrders(preservePage) {
      const gen = this.requestGeneration;
      const payload = this.buildFilterPayload();
      this.$store.dispatch("exportXls/retrieveOrdersForExport", payload).then((res) => {
        if (gen !== this.requestGeneration) return;
        if (!res) res = [];
        // Deduplicate
        res = res.filter((thing, index, self) =>
          index === self.findIndex((t) => t.id === thing.id)
        );
        for (var i = 0; i < res.length; i++) {
          this.translate(res[i]);
        }
        this.originalOrdersList = res;
        // Apply current sort
        if (this.sortProp && this.sortOrder) {
          const dir = this.sortOrder === "descending" ? -1 : 1;
          this.OrdersList = [...res].sort((a, b) => {
            const aVal = this.getNestedValue(a, this.sortProp);
            const bVal = this.getNestedValue(b, this.sortProp);
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
          });
        } else {
          this.OrdersList = res;
        }
        if (!preservePage) this.initialPage = 1;
        this.syncRouteFromState();
        this.$nextTick(() => {
          const page = preservePage ? (this.initialPage || 1) : 1;
          if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(page);
          }
        });
      });
    },

    retrieveOrdersForExport() {
      this.fetchOrders(false);
    },

    getNestedValue(obj, path) {
      if (!obj || !path) return null;
      return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : null), obj);
    },

    translate(item){
      if(item.status == "open"){
        item.status = this.i18nValues['open'];
      }
      if(item.status == "forDispatch"){
        item.status = this.i18nValues['forDispatch'];
      }
      if(item.status == "dispatched"){
        item.status = this.i18nValues['dispatched'];
      }
      if(item.status == "inPort"){
        item.status = this.i18nValues['inPort'];
      }
      if(item.status == "arrivedToDestination"){
        item.status = this.i18nValues['arrivedToDestination'];
      }
      if(item.dispatchType == "plane"){
        item.dispatchType = this.i18nValues['aerial'];
      }    
      if(item.dispatchType == "ship"){
        item.dispatchType = this.i18nValues['maritime'];
      }  
    },

    formatDispatchDate(row) {
      return this.formatDate(row.dispatchDate);
    }, 

    formatFieldSite(row) {
      for(var i = 0 ; i < this.fieldSites.length; i++){
        if(this.fieldSites[i].id == row.fieldSiteId){
          return this.fieldSites[i].name;
        }
      }
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      if (this.sortProp === nextProp && this.sortOrder === nextOrder) return;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;

      const currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      this.initialPage = currentPage;

      if (this.sortProp && this.sortOrder && this.originalOrdersList.length) {
        const dir = this.sortOrder === "descending" ? -1 : 1;
        this.OrdersList = [...this.originalOrdersList].sort((a, b) => {
          const aVal = this.getNestedValue(a, this.sortProp);
          const bVal = this.getNestedValue(b, this.sortProp);
          if (aVal == null && bVal == null) return 0;
          if (aVal == null) return 1;
          if (bVal == null) return -1;
          return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
        });
      } else {
        this.OrdersList = [...this.originalOrdersList];
      }

      this.syncRouteFromState();
      this.$nextTick(() => {
        if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
          this.$refs.pagination.currentChange(currentPage);
        }
      });
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.OrdersSubList = evt.list;
      }
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      const parseQueryArray = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value;
        if (typeof value === "string") {
          return value.split(",").filter(v => v && v.trim() !== "");
        }
        return [];
      };
      this.filter.id = q.id || null;
      this.filter.dispatchDateSince = this.coerceDate(q.dispatchDateSince);
      this.filter.dispatchDateUntil = this.coerceDate(q.dispatchDateUntil);
      this.selectedfieldSites = q.fieldSites ? parseQueryArray(q.fieldSites).map(id => Number(id)).filter(id => !isNaN(id)) : [];
      this.selectedStatuses = q.statuses ? parseQueryArray(q.statuses) : [];
      this.selectedCropTypes = q.cropTypes ? parseQueryArray(q.cropTypes) : [];
      this.selectedDispatchTypes = q.dispatchTypes ? parseQueryArray(q.dispatchTypes) : [];
      if (q.page) this.initialPage = Number(q.page);
      if (q.sortProp) this.sortProp = q.sortProp;
      if (q.sortOrder) this.sortOrder = q.sortOrder;
    },

    syncRouteFromState() {
      const q = {};
      if (this.filter.id) q.id = this.filter.id;
      if (this.selectedfieldSites && this.selectedfieldSites.length > 0) q.fieldSites = this.selectedfieldSites.join(",");
      if (this.selectedStatuses && this.selectedStatuses.length > 0) q.statuses = this.selectedStatuses.join(",");
      if (this.selectedCropTypes && this.selectedCropTypes.length > 0) q.cropTypes = this.selectedCropTypes.join(",");
      if (this.selectedDispatchTypes && this.selectedDispatchTypes.length > 0) q.dispatchTypes = this.selectedDispatchTypes.join(",");
      if (this.filter.dispatchDateSince) q.dispatchDateSince = this.serializeDate(this.filter.dispatchDateSince);
      if (this.filter.dispatchDateUntil) q.dispatchDateUntil = this.serializeDate(this.filter.dispatchDateUntil);
      const page = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex
        : this.initialPage || 1;
      if (page && page > 1) q.page = String(page);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);
      // Only navigate if query actually changed
      const current = this.$route.query || {};
      const keys = new Set([...Object.keys(q), ...Object.keys(current)]);
      let same = true;
      for (const k of keys) {
        if (String(q[k] || "") !== String(current[k] || "")) { same = false; break; }
      }
      if (!same) {
        this.$router.replace({ query: q }).catch(() => {});
      }
    },

    serializeDate(value) {
      const dt = this.coerceDate(value);
      if (!dt) {
        return undefined;
      }
      const y = dt.getFullYear();
      const m = `${dt.getMonth() + 1}`.padStart(2, "0");
      const day = `${dt.getDate()}`.padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    parseDate(value) {
      return this.coerceDate(value);
    },

    coerceDate(value) {
      return normalizeDateInput(value);
    },

    },
  };
  </script>
  
  <style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 1;
  min-width: 140px;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
  min-width: 120px;
  max-width: 100%;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
  min-width: 130px;
  max-width: 100%;
}

/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
  white-space: nowrap;
}

/* Button form items: hide the blank label but keep its height */
.filters-row /deep/ .btn-form-item .el-form-item__label {
  visibility: hidden;
}
.filters-row /deep/ .btn-form-item {
  min-width: 0;
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
  </style>